import React, { memo } from 'react'
import { format } from 'date-fns'
import Holiday from 'tve/components/appointment_grid/desktop/holiday'
import Slot from 'tve/components/appointment_grid/desktop/slot'
import { formatTime } from 'tve/helpers/date'

const Rows = memo(({ addLegend, legends, grid, value, onChange, branchId, selectBranch }) => {
  return grid.map((row) => {
    const startTime = formatTime(row[0].start)
    const endTime = formatTime(row[0].end)

    return (
      <tr key={`${startTime}-${endTime}`}>
        <td>
          {startTime} – {endTime}
        </td>
        {row.map((slot) => {
          const date = format(slot.start, 'yyyy-MM-dd')

          return slot.holiday ? (
            <Holiday key={`${date}-${startTime}-${endTime}`} addLegend={addLegend} legends={legends} slot={slot} />
          ) : (
            <Slot
              key={`${date}-${startTime}-${endTime}`}
              slot={slot}
              value={value}
              branchId={branchId}
              onChange={onChange}
              selectBranch={selectBranch}
            />
          )
        })}
      </tr>
    )
  })
})
Rows.displayName = 'Rows'

export default Rows
